/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-03 00:00:00
 *
 *******************************************************/
import React, { Component } from 'react';
import { Modal, Card, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {};
type ComposedProps = Props & WithI18nProps;

type State = {};

class RemoveTemplateModal extends Component<ComposedProps, State> {
  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  render() {
    const { i18n, open, onClose, loading, linkedWithLiveTheme = false } = this.props;

    // Render title based on theme status
    const title = linkedWithLiveTheme
      ? i18n.translate('AdminHTML.ShopifyIntegration.RemoveTemplateModal.titleUnableRemove')
      : i18n.translate('AdminHTML.ShopifyIntegration.RemoveTemplateModal.titleWarningRemove');

    return (
      <div>
        <Modal
          open={open}
          onClose={onClose}
          title={title}
          primaryAction={
            !linkedWithLiveTheme
              ? [
                  {
                    content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.remove'),
                    destructive: true,
                    onAction: () => {
                      this.props.onConfirm();
                    },
                    loading: loading
                  }
                ]
              : ''
          }
          secondaryActions={[
            {
              content: linkedWithLiveTheme
                ? i18n.translate('AdminHTML.ShopifyIntegration.Actions.close')
                : i18n.translate('AdminHTML.ShopifyIntegration.Actions.cancel'),
              onAction: this.props.onClose
            }
          ]}>
          {/* Content */}
          <div className="change-template-modal">{this.renderContent()}</div>
        </Modal>
      </div>
    );
  }

  renderContent = () => {
    const { i18n, linkedWithLiveTheme = false, templateInstance = {} } = this.props;
    const { templateName, themeIds = [] } = templateInstance;

    if (linkedWithLiveTheme) {
      return (
        <Card>
          <Card.Section>
            <div className="content">
              {i18n.translate('AdminHTML.ShopifyIntegration.RemoveTemplateModal.contentLiveTheme', {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate('AdminHTML.ShopifyIntegration.ThemeStatus.liveTheme')}
                  </TextStyle>
                )
              })}
            </div>
          </Card.Section>
        </Card>
      );
    }

    return (
      <Card>
        <Card.Section>
          <div className="content">
            {i18n.translate(
              'AdminHTML.ShopifyIntegration.RemoveTemplateModal.contentUnpublishedTheme_templateName',
              {
                t1: <TextStyle variation="strong">{templateName}</TextStyle>
              }
            )}
          </div>
          {themeIds.length > 0 ? (
            <div className="content">
              {i18n.translate(
                'AdminHTML.ShopifyIntegration.RemoveTemplateModal.contentUnpublishedTheme_templateName_linked'
              )}
            </div>
          ) : (
            ''
          )}
          <div>
            {i18n.translate('AdminHTML.ShopifyIntegration.RemoveTemplateModal.confirmMessage')}
          </div>
        </Card.Section>
      </Card>
    );
  };
}

export default withI18n()(RemoveTemplateModal);
